import React from 'react';
import ServiceHero from '../../../components/service/ServiceHero';
import QuoteForm from '../../../components/home/QuoteForm';
import ServiceTrusted from '../../../components/service/ServiceTrusted';
import ServicesSection from '../../../components/home/ServicesSection';
import DesireTechSection from '../../../components/home/DesireTechSection';
import ServiceChoose from '../../../components/service/ServiceChoose';
import ServiceArchitecture from '../../../components/service/ServiceArchitecture';
import ServiceOnboarding from '../../../components/service/ServiceOnboarding';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import AwardsSection from '../../../components/home/AwardsSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';

const LaserScanToBimPage = () => {
  return (
    <div className="laser-scan-to-bim-page">
      <style>{`
        .laser-scan-to-bim-page .hero-content {
          max-width: 1300px !important;
          width: 95% !important;
        }
        .laser-scan-to-bim-page .service-description {
          max-width: 100% !important;
        }
        .laser-scan-to-bim-page .desire-tech-subtitle {
          max-width: 850px !important;
        }
        /* Architecture Card Overrides to Centered headers */
        .laser-scan-to-bim-page .architecture-card {
          text-align: center !important;
          align-items: center !important;
          border: 2px solid #54b248 !important;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
          padding: 25px 20px !important;
        }
        .laser-scan-to-bim-page .card-icon {
          justify-content: center !important;
          margin-bottom: 20px !important;
        }
        .laser-scan-to-bim-page .architecture-card h3 {
          font-size: 24px !important;
          text-align: center !important;
          width: 100% !important;
        }
      `}</style>
      <ServiceHero
        overline="Laser Scan to BIM Services"
        staticTitle={<> <span className="text-primary">From Real-World Capture</span> to Intelligent BIM <br /> Precision</>}
        description={<>
          Capture real-world site conditions with precision using our Laser Scan to BIM services.
          We convert point cloud data into intelligent BIM models that help architects, engineers,
          contractors, and facility teams plan, design, renovate, and manage buildings with confidence.
        </>}
        buttonText="Get a Free BIM Quote"
        typingWords={[]}
      />
      <QuoteForm />
      <ServiceTrusted
        title={<><span className="text-primary">What is Laser Scan</span> to BIM?</>}
        buttonText="Book a Meeting"
        paragraphs={[
          "Laser Scan to BIM is the process of converting laser-scanned point cloud data into an accurate digital Building Information Model. It helps project teams understand the exact condition of an existing structure before design, renovation, retrofitting, or facility management work begins.",
          "Instead of relying on outdated drawings or manual site measurements, laser scanning captures the building as it truly exists. This data is then transformed into a smart 3D BIM model containing architectural, structural, and MEP elements based on project needs.",
          "Our Laser Scan to BIM services support better planning, fewer site errors, faster decision-making, and smoother project execution."
        ]}
      />
      <ServicesSection
        title={<><span className="text-primary">Our Laser Scan to</span> BIM Services</>}
        subtitle="With a team of 100+ architects, engineers, and modelers, we offer efficient architectural solutions, specializing in 3D Scan to BIM and 3D Scan to CAD services for Surveyors, Architects, and Engineers."
      />
      <DesireTechSection
        title={<><span style={{ color: '#54b248' }}>Let's Discuss Your</span> BIM & CAD Architecture Projects</>}
        subtitle="Connect with us and we will introduce you to our team of certified BIM Modelers and CAD Drafters who can turn your ideas into tailored solutions."
        buttonText="Book a Free Consultation"
        variant="contactus"
      />
      <ServiceArchitecture
        title={<><span className="text-primary">Ready to Convert Your Point Cloud</span> into an Accurate BIM Model?</>}
        description="Whether you need an as-built model for renovation, a Revit model for coordination, or detailed BIM deliverables for facility management, our team is ready to help."
        steps={[
          {
            title: "Accurate Existing Condition Documentation",
            description: "Traditional measurements can miss important details. Laser scanning captures millions of data points to reflect actual site conditions with high accuracy."
          },
          {
            title: "Better Planning for Renovation and Retrofit Projects",
            description: "For remodeling, expansion, and restoration work, understanding the current structure is critical. BIM models created from scan data help teams plan around existing conditions more effectively."
          },
          {
            title: "Reduced Rework & Clash Risks",
            description: "Accurate BIM models reduce design conflicts, unexpected site issues, and costly rework during construction."
          },
          {
            title: "Faster Design and Coordination",
            description: "Architects, engineers, and contractors can use the BIM model for design development, coordination, fabrication, and documentation."
          },
          {
            title: "Improved Facility Management",
            description: "Owners and facility managers can use the BIM model for asset tracking, maintenance planning, and future upgrades."
          }
        ]}
      />
      <ServiceOnboarding />
      <ProjectsSection />
      <TestimonialsSection />
      <BestArchitectureSection />
      <DesireTechSection 
        title={<><span style={{ color: '#54b248' }}>Looking for a</span> desired tech expert?</>}
        subtitle="Connect with us and we will introduce you to our team of certified developers who can turn your ideas into tailored solutions."
        buttonText="Connect With a Teach Expert"
      />
      <ServiceChoose 
        title={<><span className="text-primary">Why Choose</span> Laser Scan to BIM?</>}
        subtitle="The benefits of Scan to BIM in the construction process are numerous. Here are the key advantages of point cloud modeling and cost estimation."
        points={[
          { 
            title: "Skilled BIM Team", 
            desc: "Our experienced BIM professionals understand both scan data handling and modeling standards." 
          },
          { 
            title: "Accuracy-Focused Workflow", 
            desc: "We follow strict quality control checks to deliver models that match project needs" 
          },
          { 
            title: "Customized Deliverables", 
            desc: "Every project is different. We tailor our output based on discipline, LOD, software, and end use." 
          },
          { 
            title: "Fast Turnaround", 
            desc: "We work with efficient modeling workflows to support tight project timelines." 
          },
          { 
            title: "Reliable Project Support", 
            desc: "From concept to final delivery, our team stays responsive and focused on project goals." 
          }
        ]}
      />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection 
        title={<><span className="text-primary">Frequently Asked</span> Questions</>}
        faqs={[
          {
            question: "What Is The Difference Between Laser Scanning And BIM Modeling?",
            answer: "Laser scanning is the data collection process that captures the physical site as a point cloud. BIM modeling is the process of converting that raw data into an intelligent 3D representation with architectural and structural information."
          },
          {
            question: "What File Formats Do You Accept For Point Cloud Modeling?",
            answer: "We accept a wide range of laser scan formats including RCP, RCS, E57, LAS, PTS, and XYZ, ensuring compatibility with most scanning equipment."
          },
          {
            question: "Can You Create Revit Models From Laser Scan Data?",
            answer: "Yes, we specialize in converting point cloud data into high-quality Autodesk Revit models for Architecture, Structure, and MEP systems."
          },
          {
            question: "What Level Of Detail Can You Provide?",
            answer: "We provide models ranging from LOD 100 to LOD 500, tailored to your specific project needs for design, coordination, or facility management."
          },
          {
            question: "Is Laser Scan To BIM Useful For Old Buildings?",
            answer: "Absolutely. It is the most accurate way to document existing conditions for heritage buildings, renovations, and retrofit projects where original drawings may be missing."
          },
          {
            question: "Do You Provide As-Built Drawings Also?",
            answer: "Yes, in addition to 3D BIM models, we can generate detailed 2D as-built drawings, elevations, sections, and floor plans directly from the point cloud data."
          }
        ]}
      />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default LaserScanToBimPage;
